module.exports = __webpack_public_path__ + "static/img/scene-ydjs.0e6f3f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene/scene-ydjs.png
// module id = Cqki
// module chunks = 1